import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { SrIcon } from "@/components/ui/SrIcon";

interface Props {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onConfirm: () => void;
  projectName: string;
}

export function ReopenProjectDialog({ open, onOpenChange, onConfirm, projectName }: Props) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle>Åpne prosjekt på nytt?</DialogTitle>
        </DialogHeader>
        <div className="space-y-3">
          <div className="flex items-start gap-2 rounded border border-amber-200 bg-amber-50 px-3 py-2 text-sm text-amber-900">
            <SrIcon name="alert-triangle" className="w-4 h-4 mt-0.5 shrink-0" />
            <div>
              <p className="font-medium">{projectName} er for øyeblikket lukket.</p>
              <p className="text-xs mt-1">
                Åpning gjør prosjektet redigerbart igjen. Husk å lukke det på nytt
                når du er ferdig så KPI-rapporter ikke teller det som aktivt.
              </p>
            </div>
          </div>
        </div>
        <div className="flex justify-end gap-2 mt-4">
          <Button variant="outline" onClick={() => onOpenChange(false)}>
            Avbryt
          </Button>
          <Button
            onClick={() => {
              onConfirm();
              onOpenChange(false);
            }}
          >
            <SrIcon name="lock-open" className="w-4 h-4 mr-2" />
            Åpne på nytt
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}

export default ReopenProjectDialog;
